import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const { user, loading } = useSelector((state) => state.user);

  if (loading) return <p>Loading...</p>;

  return user ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;